import t from'./../../../../../ext-esm/style-inject/dist/style-inject.es.js';var a={spacing:"8",avatar:"CommentsSwitchButton_avatar__v-1Q-"};t(".CommentsSwitchButton_avatar__v-1Q-{margin:-2px}");export{a as default};
